export default {"src":"/_next/static/media/phone_verification_hand.0b9fe9bb.svg","height":1058,"width":794,"blurWidth":0,"blurHeight":0};